import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Classic::LoadingSpinnerPulse/>\n",{ moduleName: "garaje/pods/billing/loading/template.hbs" })